import React from 'react';
import { FiCheckCircle, FiMoreVertical } from 'react-icons/fi';
import MediaCover from './MediaCover';

const formatViews = (views = 0) => {
  if (views >= 10000) return `${(views / 10000).toFixed(1).replace('.0', '')}만`;
  if (views >= 1000) return `${(views / 1000).toFixed(1).replace('.0', '')}천`;
  return String(views);
};

const formatPublished = (dateString) => {
  const published = new Date(`${dateString}T00:00:00`);
  const diff = Math.max(0, Math.floor((Date.now() - published.getTime()) / 86400000));
  if (diff === 0) return '오늘';
  if (diff < 7) return `${diff}일 전`;
  if (diff < 30) return `${Math.floor(diff / 7)}주 전`;
  return `${Math.floor(diff / 30)}개월 전`;
};

const MediaCard = ({ item, onSelect }) => (
  <article className="ai-media-card">
    <button type="button" className="ai-media-card__cover" onClick={() => onSelect(item)} aria-label={`${item.title} 상세 보기`}>
      <MediaCover item={item} />
    </button>
    <div className="ai-media-card__info">
      <span className="ai-media-avatar" aria-hidden="true">{item.organization?.charAt(0) || '온'}</span>
      <button type="button" className="ai-media-card__copy" onClick={() => onSelect(item)}>
        <strong>{item.title}</strong>
        <span>
          {item.organization}
          {item.verified && <FiCheckCircle aria-label="인증 기관" />}
        </span>
        <small>조회 {formatViews(item.views)}회 · {formatPublished(item.publishedAt)}</small>
      </button>
      <button type="button" className="ai-media-card__more" aria-label={`${item.title} 메뉴`}>
        <FiMoreVertical aria-hidden="true" />
      </button>
    </div>
  </article>
);

export default MediaCard;
export { formatPublished, formatViews };
